var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPinSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 10.2305 0.246931 11.4033 0.693943 12.4715C2.548 17.5337 9.04729 21 9.04729 21C9.04729 21 17.0309 16.7421 17.8255 10.7726C17.94 10.1995 18 9.60678 18 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5647 10.6225L16.5566 10.6639L16.5511 10.7056C16.2183 13.2331 14.3326 15.5488 12.2978 17.3266C11.3063 18.1928 10.334 18.884 9.60862 19.3586C9.39788 19.4965 9.20887 19.6155 9.04735 19.7147C8.94001 19.6488 8.82052 19.5741 8.69057 19.4909C8.08355 19.1025 7.25518 18.5333 6.37374 17.8136C4.57738 16.347 2.70771 14.3736 1.90128 12.1477L1.89128 12.1201L1.88006 12.0929C1.49765 11.169 1.28577 10.1537 1.28577 9.08506C1.28577 4.77783 4.73957 1.28613 9.00005 1.28613C13.2605 1.28613 16.7143 4.77783 16.7143 9.08506C16.7143 9.61253 16.6627 10.1265 16.5647 10.6225Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinSvg);
export default __webpack_public_path__ + "static/media/MapPinSvg.723e2068a73d19f8a4d193a09a27bd50.svg";
export { ForwardRef as ReactComponent };